export const DELETE_ORDER_COMMENT = 'DELETE_ORDER_COMMENT';
export const DELETE_ORDER_COMMENT_SUCCESS = 'DELETE_ORDER_COMMENT_SUCCESS';
export const DELETE_ORDER_COMMENT_ERROR = 'DELETE_ORDER_COMMENT_ERROR';

export const DeleteOrderComment = (data) => ({
  type: DELETE_ORDER_COMMENT,
  payload: data,
});
